class CartDrawer extends HTMLElement {
  constructor() {
    super();

    $(".showmorecartpill")
      .unbind()
      .click(function () {
        $(this)
          .parent(".cart_custom_product_variant_container")
          .find(".custom_select_varcont")
          .css({ display: "block" });
        $(this).hide();
      });

    /**=======cart drawer=======**/

    $(".cart_custom_variants_pills")
      .unbind()
      .click(function () {
        $(this)
          .parents(".custom_card_recommendation")
          .find(".select-error")
          .remove();
        var thisto = $(this);
        var sel_var = $(this).attr("data-varimage");
        console.log("cartdrawerselvar==" + sel_var);
        $(this)
          .parents(".custom_card_recommendation")
          .find(".custom_card_recommendation_media img")
          .attr("src", sel_var);
        $(this)
          .parents(".custom_card_recommendation")
          .find(".variants-pills")
          .removeClass("selected");
        $(this).addClass("selected");

        var selectedcolor = $(this).data("colorname");
        var selectedsize = $(this)
          .parents(".card_recommendation_container")
          .find(".sizeselectedvar.selected .selectedvar")
          .text();
        var varname = selectedcolor + "/" + selectedsize;
        console.log("cartdrawervarname==" + varname);

        $(this)
          .parents(".custom_card_recommendation")
          .find(".comp_product_variants")
          .find("option")
          .each(function (index) {
            var varoption1 = $(this).data("option1");
            var varoption2 = $(this).data("option2");
            var varoption3 = $(this).data("option3");

            if (
              varname.indexOf(varoption1) != -1 &&
              varname.indexOf(varoption2) != -1 &&
              varname.indexOf(varoption3) != -1
            ) {
              var currid = $(this).attr("value");
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preordertextcart")
                .hide();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preorder-input")
                .remove();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".product-may-variants-all")
                .find(".product-variant-inner")
                .each(function () {
                  if ($(this).data("varid") == currid) {
                    if (
                      $(this).data("preorder") == true &&
                      $(this).data("pravailable") == true
                    ) {
                      console.log(
                        "currid==" +
                          currid +
                          "preorderid===" +
                          $(this).data("varid")
                      );
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".preordertextcart")
                        .show();
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".custom_complementary_addproduct").before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                    }
                  }
                });

              $(".cart_complemetary_product_id").val($(this).attr("value"));
            }
          });
      });

    $(".cartselected")
      .unbind()
      .on("click", function () {
        if (
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .hasClass("show")
        ) {
          $(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .not(this)
            .removeClass("show");
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .removeClass("show");
        } else {
          $(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .not(this)
            .removeClass("show");
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .addClass("show");
        }
      });

    $(".cartsizeoptionslist li")
      .unbind()
      .click(function () {
        var thisto = $(this);
        var selectedvalue = $(this).data("value");
        $(this)
          .parent(".cartsizeoptionslist")
          .parent(".sizeoptions")
          .parent(".cart_custom_drop_down_size")
          .find(".selected .selectedvar")
          .text(selectedvalue);
        $(
          ".cart_custom_drop_down_size .sizeoptions .cartsizeoptionslist"
        ).removeClass("show");

        var selectedcolor = $(this)
          .parents(".card_recommendation_container")
          .find(".cart_custom_variants_pills.selected")
          .data("colorname");
        var selectedsize = $(this).data("value");
        var varname = selectedcolor + "/" + selectedsize;
        console.log("cartdrawerselectsize==" + varname);
        $(this)
          .parents(".custom_card_recommendation")
          .find(".comp_product_variants")
          .find("option")
          .each(function (index) {
            var varoption1 = $(this).data("option1");
            var varoption2 = $(this).data("option2");
            var varoption3 = $(this).data("option3");

            if (
              varname.indexOf(varoption1) != -1 &&
              varname.indexOf(varoption2) != -1 &&
              varname.indexOf(varoption3) != -1
            ) {
              var currid = $(this).attr("value");
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preordertextcart")
                .hide();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preorder-input")
                .remove();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".product-may-variants-all")
                .find(".product-variant-inner")
                .each(function () {
                  if ($(this).data("varid") == currid) {
                    if (
                      $(this).data("preorder") == true &&
                      $(this).data("pravailable") == true
                    ) {
                      console.log(
                        "currid==" +
                          currid +
                          "preorderid===" +
                          $(this).data("varid")
                      );
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".preordertextcart")
                        .show();
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".custom_complementary_addproduct").before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                    }
                  }
                });

              $(".cart_complemetary_product_id").val($(this).attr("value"));
            }
          });
      });

    /**===========cart drawer end========**/

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    $(".sticky-addcart").click(function () {
      $(this).children(".loading-overlay__spinner").show();
      $(this).children(".cart-text").hide();
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        //  trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    $("cart-drawer").removeClass("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });

    var totalqty = $(".totalcartcount").data("totalqtycart");
    $(".cart-count-bubble").addClass("quantityincrease");
    $(".cart-count-bubble span").html(totalqty);

    $(".showmorecartpill")
      .unbind()
      .click(function () {
        $(this)
          .parent(".cart_custom_product_variant_container")
          .find(".custom_select_varcont")
          .css({ display: "block" });
        $(this).hide();
      });

    /**=======cart drawer=======**/

    $(".cart_custom_variants_pills")
      .unbind()
      .click(function () {
        $(this)
          .parents(".custom_card_recommendation")
          .find(".select-error")
          .remove();
        var thisto = $(this);
        var sel_var = $(this).attr("data-varimage");
        console.log("cartdrawerselvar==" + sel_var);
        $(this)
          .parents(".custom_card_recommendation")
          .find(".custom_card_recommendation_media img")
          .attr("src", sel_var);
        $(this)
          .parents(".custom_card_recommendation")
          .find(".variants-pills")
          .removeClass("selected");
        $(this).addClass("selected");

        var selectedcolor = $(this).data("colorname");
        var selectedsize = $(this)
          .parents(".card_recommendation_container")
          .find(".sizeselectedvar.selected .selectedvar")
          .text();
        var varname = selectedcolor + "/" + selectedsize;
        console.log("cartdrawervarname==" + varname);

        $(this)
          .parents(".custom_card_recommendation")
          .find(".comp_product_variants")
          .find("option")
          .each(function (index) {
            var varoption1 = $(this).data("option1");
            var varoption2 = $(this).data("option2");
            var varoption3 = $(this).data("option3");

            if (
              varname.indexOf(varoption1) != -1 &&
              varname.indexOf(varoption2) != -1 &&
              varname.indexOf(varoption3) != -1
            ) {
              var currid = $(this).attr("value");
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preordertextcart")
                .hide();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preorder-input")
                .remove();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".product-may-variants-all")
                .find(".product-variant-inner")
                .each(function () {
                  if ($(this).data("varid") == currid) {
                    if (
                      $(this).data("preorder") == true &&
                      $(this).data("pravailable") == true
                    ) {
                      console.log(
                        "currid==" +
                          currid +
                          "preorderid===" +
                          $(this).data("varid")
                      );
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".preordertextcart")
                        .show();
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".custom_complementary_addproduct").before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                    }
                  }
                });

              $(".cart_complemetary_product_id").val($(this).attr("value"));
            }
          });
      });

    $(".cartselected")
      .unbind()
      .on("click", function () {
        if (
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .hasClass("show")
        ) {
          $(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .not(this)
            .removeClass("show");
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .removeClass("show");
        } else {
          $(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .not(this)
            .removeClass("show");
          $(this)
            .parent(".cart_custom_drop_down_size")
            .find(".sizeoptions .cartsizeoptionslist")
            .addClass("show");
        }
      });

    $(".cartsizeoptionslist li")
      .unbind()
      .click(function () {
        var thisto = $(this);
        var selectedvalue = $(this).data("value");
        $(this)
          .parent(".cartsizeoptionslist")
          .parent(".sizeoptions")
          .parent(".cart_custom_drop_down_size")
          .find(".selected .selectedvar")
          .text(selectedvalue);
        $(
          ".cart_custom_drop_down_size .sizeoptions .cartsizeoptionslist"
        ).removeClass("show");

        var selectedcolor = $(this)
          .parents(".card_recommendation_container")
          .find(".cart_custom_variants_pills.selected")
          .data("colorname");
        var selectedsize = $(this).data("value");
        var varname = selectedcolor + "/" + selectedsize;
        console.log("cartdrawerselectsize==" + varname);
        $(this)
          .parents(".custom_card_recommendation")
          .find(".comp_product_variants")
          .find("option")
          .each(function (index) {
            var varoption1 = $(this).data("option1");
            var varoption2 = $(this).data("option2");
            var varoption3 = $(this).data("option3");

            if (
              varname.indexOf(varoption1) != -1 &&
              varname.indexOf(varoption2) != -1 &&
              varname.indexOf(varoption3) != -1
            ) {
              var currid = $(this).attr("value");
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preordertextcart")
                .hide();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".preorder-input")
                .remove();
              $(thisto)
                .parents(".custom_card_recommendation")
                .find(".product-may-variants-all")
                .find(".product-variant-inner")
                .each(function () {
                  if ($(this).data("varid") == currid) {
                    if (
                      $(this).data("preorder") == true &&
                      $(this).data("pravailable") == true
                    ) {
                      console.log(
                        "currid==" +
                          currid +
                          "preorderid===" +
                          $(this).data("varid")
                      );
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".preordertextcart")
                        .show();
                      $(this)
                        .parents(".custom_card_recommendation")
                        .find(".custom_complementary_addproduct").before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                    }
                  }
                });

              $(".cart_complemetary_product_id").val($(this).attr("value"));
            }
          });
      });

    $(".cartbundleitem").each(function () {
      // if ($(this).data("currency") != Shopify.currency.active) {
      var price = Number($(this).data("totalprice"));
      var cprice = price * Shopify.currency.rate * 100;
      $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
      // }
    });
    $(".bundleitemdiscount").each(function () {
      // if ($(this).data("currency") != Shopify.currency.active) {
      var price = Number($(this).data("discount"));
      var cprice = price * Shopify.currency.rate * 100;
      $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
      // }
    });
    $(".totalsaving").each(function () {
      // if ($(this).data("currency") != Shopify.currency.active) {
      var price =
        Number($(this).data("mainsaving")) +
        Number($(this).data("bundlesaving")) * Shopify.currency.rate;

      $(this).html(Shopify.formatMoney(price, symbol + "{{amount}}"));
      // }
    });

    var symbol = $("body").data("currency");
    $(".cartbundleitem").each(function () {
      // if ($(this).data("currency") != Shopify.currency.active) {
      var price = Number($(this).data("totalprice"));
      var cprice = price * Shopify.currency.rate * 100;
      $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
      // }
    });
    $(".bundleitemdiscount").each(function () {
      // if ($(this).data("currency") != Shopify.currency.active) {
      var price = Number($(this).data("discount"));
      var cprice = price * Shopify.currency.rate * 100;
      $(this).html(Shopify.formatMoney(cprice, symbol + "{{amount}}"));
      // }
    });
    $(".totalsaving").each(function () {
      // if ($(this).data("currency") != Shopify.currency.active) {
      var price =
        Number($(this).data("mainsaving")) +
        Number($(this).data("bundlesaving")) * Shopify.currency.rate;

      $(this).html(Shopify.formatMoney(price, symbol + "{{amount}}"));
      // }
    });

    /**===========cart drawer end========**/
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartMayItems extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      /**===========you may also like======**/

      $(".showmoremaypill")
        .unbind()
        .click(function () {
          $(this)
            .parent(".custom_product_variant_container")
            .find(".custom_select_varcont")
            .css({ display: "block" });
          $(this).hide();
        });

      $(".may_custom_variants_pills")
        .unbind()
        .click(function () {
          var thisto = $(this);
          var sel_color_var = $(this).attr("data-varimage");

          $(this)
            .parents(".custom_card_recommendation")
            .find(".custom_card_recommendation_media img")
            .attr("src", sel_color_var);

          $(this)
            .parents(".custom_card_recommendation")
            .find(".variants-pills")
            .removeClass("selected");
          $(this).addClass("selected");

          var selectedsize = $(this)
            .parents(".custom_card_recommendation")
            .find(".maysizeselectedvar.selected .selectedvar")
            .text();
          var selectedcolor = $(this).data("colornamevar");
          var varname = selectedcolor + "/" + selectedsize;

          $(this)
            .parents(".custom_card_recommendation")
            .find(".may_product_variants")
            .find("option")
            .each(function (index) {
              var varoption1 = $(this).data("option1");
              var varoption2 = $(this).data("option2");
              var varoption3 = $(this).data("option3");

              if (
                varname.indexOf(varoption1) != -1 &&
                varname.indexOf(varoption2) != -1 &&
                varname.indexOf(varoption3) != -1
              ) {
                var currid = $(this).attr("value");
                $(thisto)
                  .parents(".custom_card_recommendation")
                  .find(".preordertextcart")
                  .hide();
                $(thisto)
                  .parents(".custom_card_recommendation")
                  .find(".preorder-input")
                  .remove();
                $(thisto)
                  .parents(".custom_card_recommendation")
                  .find(".product-may-variants-all")
                  .find(".product-variant-inner")
                  .each(function () {
                    if ($(this).data("varid") == currid) {
                      if (
                        $(this).data("preorder") == true &&
                        $(this).data("pravailable") == true
                      ) {
                        console.log(
                          "currid==" +
                            currid +
                            "preorderid===" +
                            $(this).data("varid")
                        );
                        $(this)
                          .parents(".custom_card_recommendation")
                          .find(".preordertextcart")
                          .show();
                        $(this)
                          .parents(".custom_card_recommendation")
                          .find(".custom_complementary_addproduct")
                          .before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                      }
                    }
                  });

                $(".may_complemetary_product_id").val($(this).attr("value"));
              }
            });
        });

      $(".maysizeselectedvar")
        .unbind()
        .on("click", function () {
          if (
            $(this)
              .parent(".may_custom_drop_down_size")
              .find(".sizeoptions .maysizeoptionslist")
              .hasClass("show")
          ) {
            $(".may_custom_drop_down_size")
              .find(".sizeoptions .maysizeoptionslist")
              .not(this)
              .removeClass("show");
            $(this)
              .parent(".may_custom_drop_down_size")
              .find(".sizeoptions .maysizeoptionslist")
              .removeClass("show");
          } else {
            $(".may_custom_drop_down_size")
              .find(".sizeoptions .maysizeoptionslist")
              .not(this)
              .removeClass("show");
            $(this)
              .parent(".may_custom_drop_down_size")
              .find(".sizeoptions .maysizeoptionslist")
              .addClass("show");
          }
        });

      $(".maysizeoptionslist li")
        .unbind()
        .click(function () {
          var thisto = $(this);
          var selectedvalue = $(this).data("value");
          $(this)
            .parent(".maysizeoptionslist")
            .parent(".sizeoptions")
            .parent(".may_custom_drop_down_size")
            .find(".selected .selectedvar")
            .text(selectedvalue);

          $(
            ".may_custom_drop_down_size .sizeoptions .maysizeoptionslist"
          ).removeClass("show");

          var selectedcolor = $(this)
            .parents(".custom_card_recommendation")
            .find(".may_custom_variants_pills.selected")
            .data("colornamevar");
          var selectedsize = $(this).data("value");
          var varname = selectedcolor + "/" + selectedsize;
          console.log("mayyoualsoselectsize==" + varname);
          $(this)
            .parents(".custom_card_recommendation")
            .find(".may_product_variants")
            .find("option")
            .each(function (index) {
              var varoption1 = $(this).data("option1");
              var varoption2 = $(this).data("option2");
              var varoption3 = $(this).data("option3");

              if (
                varname.indexOf(varoption1) != -1 &&
                varname.indexOf(varoption2) != -1 &&
                varname.indexOf(varoption3) != -1
              ) {
                var currid = $(this).attr("value");
                $(thisto)
                  .parents(".custom_card_recommendation")
                  .find(".preordertextcart")
                  .hide();
                $(thisto)
                  .parents(".custom_card_recommendation")
                  .find(".preorder-input")
                  .remove();
                $(thisto)
                  .parents(".custom_card_recommendation")
                  .find(".product-may-variants-all")
                  .find(".product-variant-inner")
                  .each(function () {
                    if ($(this).data("varid") == currid) {
                      if (
                        $(this).data("preorder") == true &&
                        $(this).data("pravailable") == true
                      ) {
                        console.log(
                          "currid==" +
                            currid +
                            "preorderid===" +
                            $(this).data("varid")
                        );
                        $(this)
                          .parents(".custom_card_recommendation")
                          .find(".preordertextcart")
                          .show();
                        $(this)
                          .parents(".custom_card_recommendation")
                          .find(".custom_complementary_addproduct")
                          .before(`<input
                      class="preorder-input"
                      type="hidden"
                      name="properties[Preorder]"
                      value="${$(this).data("preordertext")}"
                    >`);
                      }
                    }
                  });

                $(".may_complemetary_product_id").val($(this).attr("value"));
              }
            });
        });
      /**=========end of you may also like=====**/
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("cart-may-items", CartMayItems);
